
export default {
    NO_DATA: '',
  }